var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 15 15",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.861 2.79v-.758c.225-.144.382-.383.382-.669v-.538c0-.446-.36-.807-.806-.807h-2.397c-.446 0-.807.361-.807.807v.538c0 .286.157.526.382.669v.76c-1.406.621-2.389 2.025-2.389 3.662l.002.032h-.002v7.827c0 .37.3.67.669.67h6.688c.368 0 .668-.3.668-.67v-7.859c0-1.636-.984-3.04-2.39-3.663zm1.025 6.204v4.118c-.065.303-.32.532-.642.532h-4.011c-.37 0-.67-.299-.67-.668v-6.752c.12-1.367 1.251-2.445 2.648-2.445 1.478 0 2.675 1.198 2.675 2.675z",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.423 10.065v1.816c0 .501.406.907.908.907h1.815c.502 0 .908-.406.908-.907v-3.774h-3.631zm12.167-.806c-4.397-.848-4.866 1.75-4.758 3.368 1.378-1.455 3.206-1.677 3.206-1.677l-.888.888-3.232 3.144c.19-.03.355-.077.524-.124l-.01.015s3.198-.823 3.721-1.108l.01-.007c1.133-.468 2.006-1.666 1.427-4.5z",
    fill: "#241f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnHealth);
export default __webpack_public_path__ + "static/media/icn_health.cd3c45381e0905eea31f017ee4e9b70e.svg";
export { ForwardRef as ReactComponent };